export function SetValidationValues(options: any, ruleName: string, value: any)
{
    options.rules[ruleName] = value;

    if (options.message)
    {
        options.messages[ruleName] = options.message;
    }
}